import React from 'react';
import * as styles from './GroupCard.module.scss';
import GroupCardAvatarStack from './GroupCardAvatarStack';
import CardBanner from '../components/CardBanner';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import NestableLink from '../utils/NestableLink';
import { deltaToText } from '../utils/text/deltaText';
import groupPath from '../utils/url/groupPath';

const GROUP_CARD_FRAGMENT = gql(`
  fragment GroupCard_group on Group {
    id
    description
    name
    ...groupPath_group
    banner {
      ...CardBanner_banner
    }
    members {
      id
    }
    owners {
      id
    }
    ...GroupCardAvatarStack_group
  }
`);

const GroupCard = ({
  group,
}: {
  group: DocumentType<typeof GROUP_CARD_FRAGMENT>;
}) => {
  const { banner, name, description, members, owners } = group;
  const descriptionText = deltaToText(description);
  const hasUsers = members.length > 0 || owners.length > 0;

  return (
    <NestableLink className={styles.cardContainer} to={groupPath(group)}>
      {banner && <CardBanner banner={banner} height={100} />}
      <div className={styles.innerContainer}>
        <h4 className={styles.title}>{name}</h4>
        <div className={styles.description}>{descriptionText}</div>
        {hasUsers && (
          <div className={styles.users}>
            <GroupCardAvatarStack group={group} />
          </div>
        )}
      </div>
    </NestableLink>
  );
};

export default GroupCard;
